import { Component, OnInit, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { ExceldataService } from 'src/app/services/exceldata.service';


export interface PeriodicElement {
  emailid: any;
  city: any;
  collegename: any;
  state: any;
  stream: any;
  firstname: any;
  gender: any;
  logtime: any;
  status: any;
  year: any;
  userKey: any;
}


const ELEMENT_DATA: PeriodicElement[] = [
];



@Component({
  selector: 'app-excel-data',
  templateUrl: './excel-data.component.html',
  styleUrls: ['./excel-data.component.scss']
})
export class ExcelDataComponent implements OnInit {

 userDetails:any;
  userData:any;
 length:any;
  displayedColumns: string[] = ['sno','userKey', 'emailId', 'firstname','city','stream','gender','year'];
  dataSource = new MatTableDataSource(this.userDetails);

  

  constructor(private exceldataService:ExceldataService) {
   
    this.exceldataService.currentMessage.subscribe(message =>{ this.userDetails = message;
      //this.dataSource = new MatTableDataSource(this.userDetails)
      console.log('hiii',this.userDetails);
      this.length = this.userDetails.length;
    })
    console.log(this.userDetails);
    
      
   }

  ngOnInit() {

    console.log("userData",this.userDetails)
   
    console.log("message",this.userData)
    
  }

  applyFilter(filterValue: string) {
    this.userData.filter = filterValue.trim().toLowerCase();
  }

  

}
